// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0f9252e3","453":"4797dc69","732":"310d3377","977":"c4237153"}[chunkId] + ".chunk.js";
};